var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSylized7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.660156 10.9046C0.660156 4.88216 5.54204 3.24249e-05 11.5651 3.24249e-05C17.5868 3.24249e-05 22.4687 4.88216 22.4687 10.9046C22.4687 16.9269 17.5868 21.809 11.5651 21.809C5.54204 21.809 0.660156 16.9269 0.660156 10.9046Z",
    fill: "#B7CF6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35176 8.87557C8.35176 9.62346 7.99099 10.2299 7.54706 10.2299C7.10442 10.2299 6.74365 9.62346 6.74365 8.87557C6.74365 8.12768 7.10442 7.52116 7.54706 7.52116C7.99099 7.52116 8.35176 8.12768 8.35176 8.87557Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3856 8.87557C16.3856 9.62346 16.0262 10.2299 15.5822 10.2299C15.1383 10.2299 14.7788 9.62346 14.7788 8.87557C14.7788 8.12768 15.1383 7.52116 15.5822 7.52116C16.0262 7.52116 16.3856 8.12768 16.3856 8.87557Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1602 13.375C14.6602 17.5002 8.16016 17.5003 7.66016 13.3751",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSylized7);
export default __webpack_public_path__ + "static/media/sylized_7.b4dd333f34fed085251a11ba711f3bca.svg";
export { ForwardRef as ReactComponent };